import { useState, useEffect } from 'react';
import * as d3 from 'd3';

const datafile = require('../data/111121-droogtematrix.csv');

const useData = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    d3.dsv(';', datafile).then(data => {
      setData(data)
    });
  }, []);

  return data;
};

export default useData;
